export const searchStatusChange = (state, status) => {
  state.searchStatus = !status
}

export const searchStatusHide = (state, status = false) => {
  state.searchStatus = status
}

export const menuToggle = (state) => {
  state.menuStatus = !state.menuStatus
}

export const hideMenu = (state, status = false) => {
  state.menuStatus = status
}

export const loadingToggle = (state, bool) => {
  state.loading = bool
}

export const screenSwipe = (state, bool) => {
  state.screenSwiped = bool
}

export const setPeople = (state, people) => {
    state.people = people
}

export const addOffset = (state, offset) => {
  state.offset += offset
}

export const setSlides = (state, data) => {
  state.slides = data
}

export const setSlidesIOS = (state, data) => {
  state.slidesIOS = data
}